import { useMyParcelsContext } from '@/modules/pmt/context';
import { useEmailSyncPopup } from '@/modules/pmt/hooks/useEmailSyncPopup.hook';
import { gtmViewLoginCta } from '@/utils';
import { useEffect } from 'react';
import { ANONYMOUS_ES_BANNER_IMAGE } from '../../constants';
import { useAnonymousESBannerCopy } from '../../hooks';
import { fallbackToImage } from '../../utils';
import {
  EmailSyncCTAContent,
  EmailSyncCTAWrapper,
  JoinUsButton,
  MainGraphic,
  MainText,
  NewLabel,
} from './AnonymousESBanner.styles';

export const AnonymousESBanner: React.FC = () => {
  const { notificationTranslation } = useMyParcelsContext();
  const { identifier } = notificationTranslation;
  const { newLabel, description, cta, imageUrl } = useAnonymousESBannerCopy();

  const { openEmailSyncPopup } = useEmailSyncPopup();

  useEffect(() => {
    gtmViewLoginCta(identifier);
  }, [identifier]);

  return (
    <EmailSyncCTAWrapper>
      <MainGraphic src={imageUrl} alt='Email Sync CTA' onError={fallbackToImage(ANONYMOUS_ES_BANNER_IMAGE)} />
      <NewLabel>{newLabel}</NewLabel>
      <EmailSyncCTAContent>
        <MainText>{description}</MainText>
        <JoinUsButton onClick={openEmailSyncPopup}>{cta}</JoinUsButton>
      </EmailSyncCTAContent>
    </EmailSyncCTAWrapper>
  );
};
